import React from 'react'
import { useTranslation } from 'react-i18next'

import { formatDate, formatMoney, regexPhoneNumber, chequeNumber } from 'helpers/helpers'
import { toNumber, isPreparedProduct, getPrintProduct, drawingForCheque } from 'helpers/chequePrint'

/**
 * ISH TOPSHIRIG'I — 80mm, sex monobloklari uchun (Profnastil / Aksessuar / Tunukafon).
 *
 * Oddiy chek (Cheque80) BUTUN chekni pul bilan chiqaradi. Sex ustasiga esa
 * boshqa bo'limning qatorlari ham, narx ham keraksiz — qog'oz uzayadi va
 * usta o'z ishini qidirib o'tiradi. Bu maket FAQAT o'z bo'limining qatorini,
 * rulon nomi va o'lchov hisobi bilan chiqaradi. NARX/QARZ YO'Q.
 *
 * `data.work_dept` — foydalanuvchi ko'radigan mahsulot turlari ro'yxati
 * (masalan `[4]`). Bo'sh bo'lsa bu maket umuman ishlatilmaydi (Cheque.js qaraydi).
 *
 * Ombor bu maketni OLMAYDI — unga to'liq chek + pul kerak (haydovchi qancha
 * olib kelishini bilishi shart), u Cheque80 dan `driver_note` bilan chiqadi.
 */

const DEPT_LABEL = {
	4: 'PROFNASTIL',
	3: 'AKSESSUAR',
	5: 'TUNUKAFON',
}
// Bo'lim tartibi kengashdagi ustunlar tartibi bilan bir xil
const DEPT_ORDER = [4, 3, 5]

function ChequeWork({ data = { products: [] }, printChequeRef, show = false }) {
	const { t } = useTranslation()

	// Massiv emasligiga ishonmaymiz — Cheque.js allaqachon tekshiradi, lekin bu
	// komponent yiqilsa butun sahifa oq bo'lib qoladi (chek chop etish oynasi bilan birga).
	const deptTypes = (Array.isArray(data.work_dept) ? data.work_dept : []).map(Number)

	/* ⚠️ TERMAL PRINTER — KULRANG YO'Q, FAQAT QORA (2026-08-14, foydalanuvchi talabi).
	   Termal bosh 1 bitli: nuqtani yo kuydiradi, yo yo'q. Kulrang rang esa
	   siyraklashtirish (dithering) bilan chiziladi — natijada yozuv XIRA va
	   DOG'-DOG' chiqadi, sexda o'qib bo'lmaydi.
	   Shuning uchun barcha matn `#000`. Ierarxiya rang bilan emas — SHRIFT
	   KATTALIGI va QALINLIGI bilan beriladi (ekranda ham yomon ko'rinmaydi).
	   Ajratgich chiziqlar ham qora: `#aab0bb` punktir qog'ozda umuman chiqmasdi. */
	const st = {
		wrap: { fontSize: '14px', lineHeight: 1.5, color: '#000', fontVariantNumeric: 'tabular-nums' },
		row: { display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'baseline' },
		k: { color: '#000' },
		v: { textAlign: 'right', fontWeight: 700 },
		idK: { fontSize: '30px', fontWeight: 900, color: '#000', letterSpacing: '.3px' },
		idV: { fontSize: '13px', fontWeight: 700, color: '#000', textAlign: 'right', whiteSpace: 'nowrap' },
		// Bo'lim tasmasi — qora fon, oq matn: termal printerda ham aniq chiqadi
		dept: {
			background: '#111722', color: '#fff', textAlign: 'center', fontWeight: 900,
			fontSize: '17px', letterSpacing: '1.5px', padding: '4px 0', margin: '6px 0 0',
		},
		urg: {
			border: '2px solid #b42318', color: '#b42318', textAlign: 'center', fontWeight: 900,
			fontSize: '16px', letterSpacing: '1px', padding: '2px 0', marginTop: '4px',
		},
		sepSolid: { borderTop: '2px solid #000', margin: '8px 0' },
		sepDash: { borderTop: '1px dashed #000', margin: '7px 0' },
		sepStrong: { borderTop: '3px solid #000', margin: '9px 0' },
		bigWrap: { textAlign: 'center', margin: '8px 0 3px' },
		bigK: { color: '#000', fontSize: '12px', letterSpacing: '.5px' },
		bigV: { fontSize: '21px', fontWeight: 900, letterSpacing: '.3px' },
		pname: { fontWeight: 800, fontSize: '15px' },
		/* BELGILASH KATAGI — usta bajargan ishini qalam bilan belgilaydi
		   (2026-08-13, foydalanuvchi talabi). Termal qog'ozda ingichka chegara
		   yo'qoladi, shuning uchun 2px. Qalam sig'ishi uchun 16px — undan
		   kichigi qog'ozda belgilash uchun qulay emas. */
		tick: {
			display: 'inline-block', width: '16px', height: '16px',
			border: '2px solid #111722', marginRight: '7px',
			verticalAlign: '-3px', flex: '0 0 auto',
		},
		roll: { color: '#000', fontWeight: 600 },
		calc: { fontWeight: 700 },
		hl: { background: '#fff2c2', padding: '0 3px', borderRadius: '2px' },
		note: { color: '#000', fontSize: '12px' },
		foot: { textAlign: 'center', color: '#000', fontSize: '11px', marginTop: '2px' },
	}
	const MU = 'm'

	// Chek qatorlarini bo'lim bo'yicha ajratamiz. Tayyor (ombordan olinadigan)
	// mahsulot ham chiqadi — usta uni yasamaydi, lekin zakaz to'liq ketishi uchun
	// kimdir olishi kerak; qatorni butunlay yashirish ma'lumot yo'qotish bo'lardi.
	const groups = DEPT_ORDER
		.filter(type => deptTypes.includes(type))
		.map(type => {
			const items = (data.products || [])
				.filter(p => Number(p.product_type) === type)
				.map(getPrintProduct)
				.filter(p => p.print_quantity > 0)

			const total = { metr: 0, piece: 0, kv: 0 }
			items.forEach(it => {
				if (isPreparedProduct(it)) {
					total.piece += toNumber(it.print_quantity)
				} else if (type === 5) {
					total.piece += toNumber(it.print_roll_quantity)
					total.kv += toNumber(it.print_sq_m)
				} else {
					total.metr += toNumber(it.print_metr)
				}
			})

			const parts = []
			if (total.metr > 0) parts.push(`${formatMoney(total.metr, 3)} ${MU}`)
			if (total.piece > 0) parts.push(`${formatMoney(total.piece, 3)} ${t('piece')}`)
			if (total.kv > 0) parts.push(`${formatMoney(total.kv, 3)} ${t('sq_m')}`)

			return { type, items, totalText: parts.join(' · ') }
		})
		.filter(g => g.items.length > 0)

	/* ORTIQCHA NOLLARSIZ son (2026-08-13, foydalanuvchi talabi).
	   «1.050 м × 60.000 дона» o'rniga «1.05 м × 60 дона» — usta uchun
	   uch xonalik aniqlik shovqin, o'qishni sekinlashtiradi.
	   ⚠️ Aniqlik YO'QOLMAYDI: 3 xonagacha formatlanadi, keyin faqat
	      ma'nosiz nollar qirqiladi (1.500 → 1.5, lekin 1.505 → 1.505). */
	const nz = (v, d = 3) => {
		const s = formatMoney(v, d)
		return s.includes('.') ? s.replace(/\.?0+$/, '') : s
	}

	const line = (item, index) => {
		const prepared = isPreparedProduct(item)
		const type = Number(item.product_type)
		/* RULONDAN NECHA METR KETADI — tunukafon uchun (foydalanuvchi talabi).
		   Mahsulot metri bilan rulon metri BIR XIL EMAS: eni 0.625, rulon 1.25
		   bo'lsa bitta kesimdan 2 bo'lak chiqadi. Ya'ni 1.05 × 60 dona = 63 m
		   mahsulot, lekin rulondan atigi 31.5 m ketadi va usta 30 marta kesadi.
		   Bu yozilmasa usta 63 metr kesishga urinadi — ikki barobar ortiqcha. */
		const rollM = toNumber(item.roll_metr)
		const cuts = toNumber(item.element_quantity) > 0
			? rollM / toNumber(item.element_quantity)
			: 0

		/* ЁЙМА va BITTA VARAQDAN NECHA BO'LAK — chizma ichidan (foydalanuvchi talabi).
		   `draw_json` chekka `chp.*` bilan keladi (ChequeController :2716).
		   Drayverga qarab u satr ham, obyekt ham bo'lishi mumkin — ikkalasi
		   ham qo'llab-quvvatlanadi, aks holda bitta muhitda jimgina yo'qolardi. */
		let dj = item.draw_json
		if (typeof dj === 'string') { try { dj = JSON.parse(dj) } catch (e) { dj = null } }
		const blankMM = toNumber(dj && dj.blank)
		const bolak = toNumber(dj && dj.bolak)
		return (
			<div>
				{/* Katak + nom bir qatorda: nom uzun bo'lsa katak tepada qolib
				    ketmasin, matn ostiga tushmasin */}
				<div style={{ display: 'flex', alignItems: 'flex-start' }}>
					<span style={st.tick}></span>
					<div style={st.pname}>{index + 1}. {item.product_name}</div>
				</div>
				{item.element_name && <div style={st.roll}>{t('roll')}: {item.element_name}</div>}

				{prepared ? (
					<div style={st.calc}>
						<span style={st.hl}>{formatMoney(item.print_quantity, 3)} {t('piece')}</span>
						<span style={st.note}> · {t('from_warehouse')}</span>
					</div>
				) : (
					<>
						<div style={st.calc}>
							{nz(item.element_quantity)} {MU} × {nz(item.print_roll_quantity)} {t('piece')}
							{' = '}<span style={st.hl}>{nz(item.print_metr)} {MU}</span>
						</div>
						{/* CHEREPITSA: BOSHI + SHAG — USTANING PRESS SOZLAMASI (2026-08-27).
						    Sotuvchi kiritadi (Cashbox), usta shu bo'yicha pressni sozlaydi —
						    «har biri qo'lda yozilsa adashilmovchilik bo'lmaydi» (egasi).
						    Ataylab yirik: bu qator uchun ish topshirig'idagi ENG muhim son. */}
						{((item.tile_start_sm ?? '') !== '' || (item.tile_step_sm ?? '') !== '') &&
							<div style={{ ...st.calc, fontSize: '17px', fontWeight: 800 }}>
								{(item.tile_start_sm ?? '') !== '' && <>{t('tile_start').toUpperCase()}: <span style={st.hl}>{nz(item.tile_start_sm, 1)} {t('sm_unit')}</span></>}
								{(item.tile_start_sm ?? '') !== '' && (item.tile_step_sm ?? '') !== '' && ' · '}
								{(item.tile_step_sm ?? '') !== '' && <>{t('tile_step').toUpperCase()}: <span style={st.hl}>{nz(item.tile_step_sm, 1)} {t('sm_unit')}</span></>}
							</div>}
						{/* RULONDAN — faqat tunukafonda va faqat mahsulot metridan
						    FARQ QILGANDA. Aksessuar/profnastilda ikkisi teng,
						    bir xil raqamni ikki marta yozish chalkashtiradi. */}
						{type === 5 && rollM > 0 && Math.abs(rollM - toNumber(item.print_metr)) > 0.01 &&
							<div style={st.calc}>
								{t('from_roll')}: <span style={st.hl}>{nz(rollM)} {MU}</span>
								{cuts > 0 && <span style={st.note}> · {nz(cuts)} {t('cuts')}</span>}
							</div>}
						{/* Tunukafonda kv.m qatori ATAYLAB yo'q — usta dona va metr bilan ishlaydi,
						    kv.m faqat pastdagi JAMI da kerak (user qarori). */}
						{/* ENI — endi TUNUKAFONDA HAM (2026-08-13, foydalanuvchi talabi).
						    Tunukafonda eni mahsulotni ajratib turadigan asosiy o'lcham:
						    karniz 0.2083, doska 0.625 — ikkisi butunlay boshqa mahsulot,
						    usta faqat nomga qarab adashishi mumkin edi. */}
						{(type === 3 || type === 5) && (toNumber(item.draw_width) > 0 || toNumber(item.width) > 0) &&
							<div style={st.note}>
								{t('width')}: {formatMoney(toNumber(item.draw_width) > 0 ? item.draw_width : item.width, 4)} {MU}
								{toNumber(item.draw_width) > 0 && <b> ({t('by_drawing')})</b>}
							</div>}

						{/* ЁЙМА va 1 varaqdan necha bo'lak — chizmali qatorda.
						    Yoyma = bitta dona uchun kerak bo'ladigan tekis uzunlik;
						    bo'lak = rulon enidan nechta shunday dona qirqiladi. */}
						{blankMM > 0 &&
							<div style={st.note}>
								{t('blank')}: {nz(blankMM, 0)} mm
								{bolak > 1 && <> · {t('pieces_per_sheet_short', { n: nz(bolak, 0) })}</>}
							</div>}
						{/* CHIZMA — ustaning eng muhim ma'lumoti. Ilgari u «Tarnov 4b»
						    nomidan qanday buklashni YODDAN bilishi kerak edi.

						    ⚠️ 2026-08-13: ikkita o'zgarish.
						    1) `type === 3` sharti OLIB TASHLANDI — chizma bor-yo'qligi
						       bo'yicha ko'rsatiladi. Tunikofon (tur 5) ham chizma
						       oladigan bo'lsa, bu joyni yana tahrirlash kerak emas.
						    2) Eni 260px bilan cheklanmaydi — 80 mm chekning BUTUN
						       enidan foydalanadi. Chizmada endi o'lchamlar va
						       burchaklar bor (drawingGeometry.js → drawingSvg),
						       ular kichraytirilsa o'qib bo'lmasdi. */}
						{drawingForCheque(item, 'worker') &&
							<img src={drawingForCheque(item, 'worker')} alt=""
								style={{
									display: 'block', width: '100%', margin: '5px 0 3px',
									border: '1px solid #000', boxSizing: 'border-box',
								}} />}
					</>
				)}
			</div>
		)
	}

	return (
		<div className={`${show ? '' : 'd-none'}`}>
			<div className={`cheque print ${show ? 'p-3' : 'print'} w80mm`} ref={printChequeRef} style={st.wrap}>
				{/* № + ochilgan vaqt. Logo/manzil yo'q — bu ichki qog'oz, joy tejaladi. */}
				<div style={{ ...st.row, alignItems: 'center' }}>
					<span style={st.idK}>№ {chequeNumber(data)}</span>
					<span style={st.idV}>{formatDate(data.cheque_opened_at, "dd.MM.yyyy HH:mm")}</span>
				</div>

				{groups.length === 1 && <div style={st.dept}>{DEPT_LABEL[groups[0].type]}</div>}
				{data.is_urgent && <div style={st.urg}>⚡ {t('urgent')}</div>}

				<div style={st.sepSolid}></div>

				<div style={st.row}><span style={st.k}>{t('seller')}</span><span style={st.v}>{data.cashier_name}</span></div>
				{data.cashier_phone &&
					<div style={st.row}><span style={st.k}>{t('phone')}</span><span style={{ ...st.v, whiteSpace: 'nowrap' }}>{regexPhoneNumber(data.cashier_phone)}</span></div>}
				<div style={st.sepDash}></div>
				<div style={st.row}><span style={st.k}>{t('client')}</span><span style={st.v}>{data.client_name}</span></div>
				{[data.client_region, data.address].filter(Boolean).length > 0 &&
					<div style={st.row}>
						<span style={st.k}>{t('address')}</span>
						<span style={st.v}>{[data.client_region, data.address].filter(Boolean).join(', ')}</span>
					</div>}

				{data.delivery_date &&
					<div style={st.bigWrap}>
						<div style={st.bigK}>{t('deadline')}</div>
						<div style={st.bigV}>{formatDate(data.delivery_date, "dd.MM.yyyy HH:mm")}</div>
					</div>}

				<div style={st.sepSolid}></div>

				{groups.length === 0 &&
					<div style={{ ...st.note, textAlign: 'center', padding: '10px 0' }}>{t('wo_empty')}</div>}

				{groups.map(g => (
					<div key={g.type}>
						{/* Bir necha bo'limli foydalanuvchida har bo'lim o'z tasmasi bilan */}
						{groups.length > 1 && <><div style={{ ...st.dept, margin: '0 0 6px' }}>{DEPT_LABEL[g.type]}</div></>}
						{g.items.map((it, i) => (
							<React.Fragment key={i}>
								{i > 0 && <div style={st.sepDash}></div>}
								{line(it, i)}
							</React.Fragment>
						))}
						<div style={st.sepStrong}></div>
						<div style={st.bigWrap}>
							<div style={st.bigK}>{t('total')}</div>
							<div style={st.bigV}>{g.totalText}</div>
						</div>
						<div style={st.sepStrong}></div>
					</div>
				))}

				{data.note && <div style={st.note}>{t('note')}: {data.note}</div>}
				<div style={st.foot}>{t('work_order')}</div>
			</div>
		</div>
	)
}

export default ChequeWork
